export const notifications = {
    warning: {
        header: "Il semble qu'une erreur se soit produite.",
        body: 'Veuillez vérifier votre connexion ou réessayer plus tard.',
    },
    repairingFile: {
        header: 'Optimisation nécessaire',
        body: "Votre fichier n'est pas encore optimisé pour l'impression 3D. Veuillez attendre un moment pour que notre logiciel d'optimisation répare votre fichier.",
    },
    holiday_leave: {
        header: "Information importante",
        body: "Les commandes passées après le 16.12.2022 ne seront livrées qu’à partir de la 2e semaine civile 2023."
    }
};
